import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { valueByType } from 'modules/core/components/ActivityLog/Log/Item/Changes/ValueTypes'
import { Change } from 'modules/core/components/ActivityLog/Log/types'

export const Updates = ({ change }: Change) => {
  const hasValue = change.value?.value !== undefined && change.value?.value !== null
  const hasOldValue = change.old_value?.value !== undefined && change.old_value?.value !== null

  return (
    <Box flexDirection="row">
      {change.title && (
        <Box flexDirection="row" paddingRight="s4" alignItems="flexStart">
          <Text.Normal size="200" color="grey800" whiteSpace="nowrap">
            {change.title}:&nbsp;
          </Text.Normal>
        </Box>
      )}

      <Box flexDirection="row" alignItems="center" gap="s4" flexWrap="wrap" paddingTop="s1">
        {hasOldValue && (
          <Box flexDirection="row" alignItems="center" gap="s4">
            <Text.Normal color="grey600" size="200" stroked>
              {valueByType(change.old_value, true)}
            </Text.Normal>
            {hasValue && <Icon.Small icon="arrow-right" color="grey800" />}
          </Box>
        )}
        {hasValue && (
          <Box>
            <Text.Normal
              weight="medium"
              color="grey1000"
              size="200"
              {...(!hasOldValue && { weight: 'medium' })}
            >
              {valueByType(change.value)}
            </Text.Normal>
          </Box>
        )}
      </Box>
    </Box>
  )
}
